var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftBar" },
    [
      _c("v-drawer", { attrs: { direction: "left", width: "26%" } }, [
        _c(
          "div",
          { staticClass: "animated fadeInLeftBig dx" },
          [
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("种植分布")]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [_c("left-zzfb")],
                  1
                ),
              ],
              1
            ),
            _c(
              "bar-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v(_vm._s(_vm.sjObj.name))]),
                _c(
                  "div",
                  { staticClass: "panelContent" },
                  [_c("right-top")],
                  1
                ),
              ],
              1
            ),
            _c(
              "left-card",
              { staticClass: "lefts lefts2", attrs: { bg: "border2" } },
              [
                _c("v-title", [_vm._v("茂名荔枝产业历史发展情况")]),
                _c("div", { staticClass: "panelContent" }, [_c("left-top")], 1),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }